import React from "react";

export const PersonalInfoStep = ({
  formData,
  errors,
  genderOptions,
  mobileMaxLength,
  onChange,
}) => (
  <React.Fragment>
    <div className="grid-item">
      <select
        name="title"
        id="title"
        value={formData.title}
        onChange={onChange}
        required
        style={{ borderColor: errors.title ? "#dc3545" : "" }}
      >
        <option value="" disabled hidden>
          Title *
        </option>
        <option value="Dr.">Dr.</option>
        <option value="Mr.">Mr.</option>
        <option value="Ms.">Ms.</option>
        <option value="Mrs.">Mrs.</option>
        <option value="Prof.">Prof.</option>
      </select>
      {errors.title && <p className="error-text">{errors.title}</p>}
    </div>
    <div className="grid-item">
      <input
        name="firstName"
        placeholder="First Name *"
        value={formData.firstName}
        onChange={onChange}
      />
      {errors.firstName && <p className="error-text">{errors.firstName}</p>}
    </div>
    <div className="grid-item">
      <input
        name="lastName"
        placeholder="Last Name *"
        value={formData.lastName}
        onChange={onChange}
      />
      {errors.lastName && <p className="error-text">{errors.lastName}</p>}
    </div>
    <div className="grid-item">
      <input
        name="email"
        placeholder="Email *"
        value={formData.email}
        onChange={onChange}
      />
      {errors.email && <p className="error-text">{errors.email}</p>}
    </div>
    <div className="grid-item">
      <input
        type="tel"
        name="mobile"
        placeholder="Phone/Mobile Number *"
        value={formData.mobile}
        onChange={onChange}
        maxLength={mobileMaxLength}
        inputMode="numeric"
        pattern="[0-9]*"
      />
      {errors.mobile && <p className="error-text">{errors.mobile}</p>}
    </div>
    {genderOptions.length > 0 && (
      <div className="grid-item">
        <select
          name="gender"
          id="gender"
          value={formData.gender}
          onChange={onChange}
          required
          style={{ borderColor: errors.gender ? "#dc3545" : "" }}
        >
          <option value="" disabled hidden>
            Gender *
          </option>
          {genderOptions.map((option) => (
            <option key={option.id} value={option.value}>
              {option.value}
            </option>
          ))}
        </select>
        {errors.gender && <p className="error-text">{errors.gender}</p>}
      </div>
    )}
  </React.Fragment>
);
